<nb-list>
  <nb-list-item *ngFor="let item of equiposAplicadores;let i = index" >
      <div class="row full-width">
          <div class="col-sm-5">
              <p class="first-line"><nb-icon icon="tractor" pack="font-awesome"></nb-icon><span class="item-label">{{item.equipo.nombre}}</span></p>
              <p class="second-line">{{item.equipo.registro}}</p>
          </div>
           <div class="col-sm-5">
              <p class="first-line"><nb-icon icon="user" pack="font-awesome"></nb-icon><span class="item-label">{{item.aplicador.nombre}}</span></p>
              <p class="second-line">{{item.aplicador.registro}}</p>
          </div>

          <div class="col-sm-2 btn-container">
             <button nbButton shape="round" size="small" status="danger" (click)="deleteEquipoAplicador(i)"><nb-icon icon="trash-2-outline"></nb-icon></button>
          </div>
      </div>
  </nb-list-item>
</nb-list>

<div class="row full-width">
  <div class="col-sm-5">
    <ngx-item-selector
    [getKey]="calcularIdItem" [renderValue]="calcularLabelItem"
    [dataSource]="equipos"
    [(selectedData)]="newEquipoAplicador.equipo">
    </ngx-item-selector>

</div>
 <div class="col-sm-5">
  <ngx-item-selector
  [getKey]="calcularIdItem" [renderValue]="calcularLabelItem"
  [dataSource]="aplicadores"
  [(selectedData)]="newEquipoAplicador.aplicador">
  </ngx-item-selector>
</div>

<div class="col-sm-2 btn-container">
   <button [disabled]="newEquipoAplicador.aplicador.identifier == undefined || newEquipoAplicador.equipo.identifier == undefined" nbButton shape="round" size="small" status="success" (click)="addEquipoAplicador()">Añadir</button>
</div>

</div>
